import { useSyncExternalStore } from 'react';

const DESKTOP_QUERY = '(min-width: 48rem)';

function subscribe(onChange: () => void) {
  if (typeof window === 'undefined' || !window.matchMedia) {
    return () => undefined;
  }
  const mediaQuery = window.matchMedia(DESKTOP_QUERY);
  mediaQuery.addEventListener('change', onChange);
  return () => mediaQuery.removeEventListener('change', onChange);
}

function getSnapshot() {
  if (typeof window === 'undefined' || !window.matchMedia) return true;
  return window.matchMedia(DESKTOP_QUERY).matches;
}

/** Mounts only the desktop or mobile branch for responsive list components. */
export function useIsDesktop() {
  return useSyncExternalStore(subscribe, getSnapshot, () => true);
}
